const redirects: {
  match: RegExp;
  redirectTo: string;
}[] = [
  // {
  //   match: /^\/admin\/?$/,
  //   redirectTo: '/admin/homepage/'
  // },
];

export default defineNuxtRouteMiddleware(async (to, from) => {
  for (const redirect of redirects) {
    if (redirect.match.test(to.path)) {
      return navigateTo(redirect.redirectTo);
    }
  }
});
